import { useModal } from "@ebay/nice-modal-react";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import useQueryStringState from "components/hooks/useQueryStringState";
import { EditButton } from "components/ui/atoms/Button";
import Layout from "components/ui/molecules/Layout";
import TimeLine from "models/actions/Timeline";
import CompanyDealsAndSourcings from "models/companies/CompanyDealsAndSourcings";
import CompanyHeader from "models/companies/CompanyHeader";
import CompanyView from "models/companies/CompanyView";
import DealFlowCompanyStates from "models/companies/DealFlowCompanyStates";
import FinancialsWidget from "models/companies/FinancialsWidget";
import { useCompany, useResetCompany } from "models/companies/apiCompany";
import { useLogHistory } from "models/history/apiHistory";
import NoteWidget from "models/notes/NoteWidget";
import SocialCompanyWidget from "models/social/SocialCompanyWidget";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const CompanyDetail = ({}) => {
  const { company_id } = useParams();
  const [queryState, setQueryState] = useQueryStringState();

  const resetCompany = useResetCompany();
  const {
    data: company,
    isLoading: companyIsLoading,
    isError: companyIsError,
    isSuccess,
    error,
  } = useCompany(company_id);
  const handleLog = useLogHistory("app.company");
  const companyModal = useModal("CompanyDrawer");
  const snapshotModal = useModal("SnapshotDrawer");

  useEffect(() => {
    isSuccess && handleLog(company.id);
  }, [companyIsLoading, company?.id]);

  const setTimeLineState = (innerState) => {
    setQueryState((state) => ({ ...state, timeline: innerState }));
  };

  if (companyIsLoading) return <Skeleton variant="rectangular" height={150} />;
  if (companyIsError) {
    return <>{error.message}</>;
  }

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <CompanyHeader
          company={company}
          toggleOpenSnapshotList={() =>
            snapshotModal.show({
              id: company.id,
            })
          }
        />
      </Layout>
      <Layout content>
        <DealFlowCompanyStates companyId={company.id} />
      </Layout>
      <Layout content>
        <EditButton
          onClick={() =>
            companyModal
              .show({
                formType: "update",
                id: company.id,
              })
              .then(() => resetCompany(company.id))
          }
        />
        <CompanyView company={company} />
      </Layout>
      <Layout content>
        <Grid container spacing={2}>
          <Grid size={{ md: 6, xs: 12 }}>
            <SocialCompanyWidget companyId={company.id} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <NoteWidget companyId={company.id} />
          </Grid>
        </Grid>
      </Layout>
      <Layout content>
        <CompanyDealsAndSourcings
          state={queryState.dealsAndSourcings}
          setState={(dealsAndSourcingsState) =>
            setQueryState(
              {
                ...queryState,
                dealsAndSourcings: dealsAndSourcingsState || undefined,
              },
              { replace: !queryState.dealsAndSourcings },
            )
          }
          companyIds={[company.id]}
        />
      </Layout>
      <Layout content>
        <EditButton
          onClick={() =>
            companyModal
              .show({
                formType: "update",
                id: company.id,
              })
              .then(() => resetCompany(company.id))
          }
          w={1}
        />
        <FinancialsWidget companyId={company.id} />
      </Layout>
      <Layout content>
        <TimeLine
          companyDomains={company.domains}
          state={queryState.timeline || {}}
          setState={setTimeLineState}
        />
      </Layout>
    </Layout>
  );
};

export default CompanyDetail;
